import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import SalePackages from '../SalePackagesBlock/SalePackages';
import {isMobile} from 'react-device-detect';
import {saveSelectedMarketPackage} from '../ChangePricePlanBlock/changePricePlanSlice';
import TagName from '../../Shared/TagName';
import {gtag4} from '../../../utilities/analytics/tracking';
import {dwhPageDisplay, dwhOfferButtonClicked} from './dwhReports';
import {removeHTMLTags} from '../../../utilities/StringHelpers/StringHelpers';

const ChangePricePlanMarketMain = (props) => {
  const title = !isMobile ? props.iContent.titleDesktop.value : props.iContent.titleMobile.value;
  const subtitle = !isMobile ? props.iContent.subTitleDesktop.value : props.iContent.subTitleMobile.value;
  const pageURL = window.location.href;
  useEffect(() => {
    //DWH
    dwhPageDisplay(pageURL);
  }, []);
  const saveSelectedPackage = async (packageData) => {
    //GA
    gtag4({
      event: 'CellPackUpdateP1_Step1_PackageClick',
      step: '1',
      title: title,
      action: 'PackageClick',
      button: packageData.buttonText,
      package: removeHTMLTags(packageData.title),
      badge: packageData.benefitTitle,
    });
    //DWH
    const offerId = packageData.offerID;
    dwhOfferButtonClicked(offerId, pageURL);

    const url = props.iContent.urlToChangePricePlanBlock?.value?.url;
    await props.saveSelectedMarketPackage(packageData);
    const content = await props.context.loadContentByPath(url);
    props.context.navigateTo(content);
  };

  return (
    <div className='change-price-plan-market-container'>
      <div className='BlockWrapper__head'>
        {title && (
          <TagName isTitle className='BlockWrapper__title'>
            {title}
          </TagName>
        )}
        {subtitle && <TagName className='BlockWrapper__subtitle'>{subtitle}</TagName>}
      </div>
      <SalePackages
        packages={props.iContent.packagesList}
        onSelectedPackages={(packageData) => saveSelectedPackage(packageData)}
        oneTimeFee={true}
        isChangePricePlan={true}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.changePricePlan,
  };
};

const mapDispatchToProps = {saveSelectedMarketPackage};
export default connect(mapStateToProps, mapDispatchToProps)(ChangePricePlanMarketMain);
